import { toast } from "react-toastify";
import { Icon } from "@scuf/common";
import { useEffect } from "react";
import { useRef } from "react";

/**
 * Función que monitorea el status de la conexion a internet
 */
export default function ConectionStatus() {
  const toastId = useRef(null);
  /**
   * Notificación de perdida y conexion de internet
   * @param {*} message - string
   * @param {*} type - string
   */
  function notify(message, type) {
    if (type === "conected") {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.success(message, {
          toastId: "conection-status-conected",
          icon: <Icon root="common" name="wifi" size="small" />,
        });
      }
    } else if (type === "disconected") {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning(message, {
          toastId: "conection-status-disconected",
          icon: <Icon root="common" name="wifi" size="small" />,
        });
      }
    }
  }

  // Efecto para escuchar eventos y removerlos
  useEffect(() => {
    // Estamos escuchando el evento offline (sin conexion a internet)
    window.addEventListener("offline", (e) => {
      notify("Se perdio la conexión a internet", "disconected");
    });

    // Estamos escuchando el evento online (con conexion a internet)
    window.addEventListener("online", (e) => {
      notify("Se establecio la conexión a internet!", "conected");
    });
    // limpiamos este componente y sus eventos
    return () => {
      window.removeEventListener("offline", (e) => {});
      window.removeEventListener("online", (e) => {});
    };
  }, []);
}
